/**
 * useBuddyGroup — single group detail query.
 */

import { useQuery } from '@tanstack/react-query';
import { buddyGroupAdminKeys, fetchBuddyGroup } from '../buddy-group-service';

export function useBuddyGroup(groupId: string) {
  return useQuery({
    queryKey: buddyGroupAdminKeys.detail(groupId),
    queryFn: () => fetchBuddyGroup(groupId),
    enabled: !!groupId,
  });
}
